import React from 'react'
import QuickPanel from 'app/fuse-layouts/shared-components/quickPanel/QuickPanel'

function RightSideLayoutMain() {
  return (
    <React.Fragment>
      <QuickPanel />
    </React.Fragment>
  )
}

export default RightSideLayoutMain
